import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import Sponsors from 'components/NextconLabSponsors/Sponsors';

function Fsponsors() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Sponsors/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Sponsors/>
        <Footer />
      </>
    )}
    </>
  );
}

export default Fsponsors;
